module.exports = __webpack_public_path__ + "static/media/automotive.48de2a32.png";